var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader', {
    ref: "sortHeader",
    model: {
      value: (_vm.sortParam),
      callback: function($$v) {
        _vm.sortParam = $$v
      },
      expression: "sortParam"
    }
  }), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi,
      "isRefresh": _vm.isRefresh
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "w1200 bc"
  }, [_c('div', {
    staticClass: "hq-crumb-wrap"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "item sep"
  }, [_vm._v(">")]), _vm._v(" "), _c('li', {
    staticClass: "item"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn) + _vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
    staticClass: "sp-side-wrap"
  }, [_vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.recommendGoodsList), function(recommendGood) {
    return _c('li', [_c('a', {
      staticClass: "fl pic",
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": recommendGood.imgMiddle,
        "width": "106",
        "height": "106"
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(recommendGood.goodsCode, recommendGood.productType)
        }
      }
    }, [_vm._v(_vm._s(recommendGood.goodsName))])]), _vm._v(" "), (recommendGood.productType != 'sample' && recommendGood.goodsPrice > 0) ? _c('p', {
      staticClass: "price co2"
    }, [_vm._v(_vm._s(recommendGood.goodsPrice) + "积分")]) : _vm._e(), _vm._v(" "), (recommendGood.productType != 'sample' && recommendGood.goodsPrice == 0) ? _c('p', {
      staticClass: "price co2"
    }, [_vm._v(_vm._s(recommendGood.unitPrice == 0 ? "" : "￥" + (recommendGood.unitPrice / 100).toFixed(2)))]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "sp-search-list"
  }, [_c('div', {
    staticClass: "l-hd"
  }, [_c('div', {
    staticClass: "top-num fr"
  }, [_vm._v("共" + _vm._s(_vm.totalItem) + "条 "), _c('span', {
    staticClass: "co2"
  }, [_vm._v(_vm._s(_vm.sortParam) + _vm._s(_vm.catNameCn))])]), _vm._v(" "), _c('h3', [_vm._v("搜索结果")])]), _vm._v(" "), _c('div', {
    staticClass: "hq-selector"
  }, [_c('div', {
    staticClass: "hd"
  }, [_c('dl', [_c('dt', [_vm._v("已选条件：")]), _vm._v(" "), _c('dd', {
    attrs: {
      "id": "choosedCond"
    }
  }, _vm._l((_vm.choosedCondItem), function(condItem, index) {
    return _c('span', {
      staticClass: "checked-item",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "condType": condItem.condType
      }
    }, [_vm._v(_vm._s(condItem.condName)), _c('a', {
      staticClass: "del",
      on: {
        "click": function($event) {
          _vm.removeCondition(index, condItem.condType)
        }
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [(_vm.firstCatList != undefined && _vm.firstCatList.length > 0) ? _c('dl', [_c('dt', [_vm._v("主类")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_h"
  }, _vm._l((_vm.firstCatList), function(firstCat, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'firstCat', firstCat.catCode)
        }
      }
    }, [_vm._v(_vm._s(firstCat.catNameCn))])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.twoCategoryList != undefined && _vm.twoCategoryList.length > 0) ? _c('dl', [_c('dt', [_vm._v("分类")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_h"
  }, _vm._l((_vm.twoCategoryList), function(twoCategory, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'catNameCn', twoCategory.catCode)
        }
      }
    }, [_vm._v(_vm._s(twoCategory.catNameCn))])
  }))])]) : _vm._e(), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("品牌")]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "td_brand_h"
  }, _vm._l((_vm.brandList), function(brand, index) {
    return _c('a', {
      staticStyle: {
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.chooseCondition($event, 'brand', brand.id)
        }
      }
    }, [_vm._v(_vm._s(brand.brandNameCn))])
  }))])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("价格：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', 'intervalAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '0,100')
      }
    }
  }, [_vm._v("0-100")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '101,200')
      }
    }
  }, [_vm._v("101-200")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '201,300')
      }
    }
  }, [_vm._v("201-300")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '301,500')
      }
    }
  }, [_vm._v("301-500")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '501,1000')
      }
    }
  }, [_vm._v("501-1000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '1001,5000')
      }
    }
  }, [_vm._v("1001-5000")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'amount', '5000,')
      }
    }
  }, [_vm._v("5000以上")])])]), _vm._v(" "), _c('dl', [_c('dt', [_vm._v("发布时间：")]), _vm._v(" "), _c('dd', [_c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'timeAll')
      }
    }
  }, [_vm._v("不限")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneDay')
      }
    }
  }, [_vm._v("一天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'twoDay')
      }
    }
  }, [_vm._v("两天内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneWeek')
      }
    }
  }, [_vm._v("一周内")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.chooseCondition($event, 'time', 'oneMonth')
      }
    }
  }, [_vm._v("一月内")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pro-tool mt20"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', {
    class: {
      "hover": _vm.sortCondition === "defaultSort"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('defaultSort')
      }
    }
  }, [_vm._v("默认")]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "saleAmount"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('saleAmount')
      }
    }
  }, [_vm._v("销量"), _c('i', {
    class: {
      "up": _vm.sortSaleAmount == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "publishTime"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('publishTime')
      }
    }
  }, [_vm._v("发布时间"), _c('i', {
    class: {
      "up": _vm.sortPublishTime == "asc"
    }
  })]), _vm._v(" "), _c('li', {
    class: {
      "hover": _vm.sortCondition === "price"
    },
    on: {
      "click": function($event) {
        _vm.sortGoods('price')
      }
    }
  }, [_vm._v("价格"), _c('i', {
    class: {
      "up": _vm.sortPrice == "asc"
    }
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "input-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lower),
      expression: "lower"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.lower)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lower = $event.target.value
      }
    }
  }), _vm._v(" - "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.upper),
      expression: "upper"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.upper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.upper = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "price-tool"
  }, [_c('div', {
    staticClass: "price-tool-btn"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.clearUserDefined()
      }
    }
  }, [_vm._v("清空")])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.userDefinedCondition()
      }
    }
  }, [_vm._v("确定")])])])])])])])])]), _vm._v(" "), (_vm.firstCatCode != 'spike') ? _c('div', {
    staticClass: "pro-list"
  }, [_c('ul', _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "img"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "20%",
        "float": "right",
        "text-align": "right"
      },
      attrs: {
        "id": "alert_btn"
      }
    }, [(goodsBo.seven_day_return == 'Y') ? _c('img', {
      staticStyle: {
        "width": "17px",
        "height": "17px"
      },
      attrs: {
        "src": require("../../../static/images/qitian.png")
      }
    }) : _vm._e()]), _vm._v(" "), (goodsBo.goodsPrice > 0 && goodsBo.productType != 'sample') ? _c('p', {
      staticClass: "price"
    }, [_vm._v(" " + _vm._s(goodsBo.goodsPrice) + "积分")]) : _vm._e(), _vm._v(" "), (goodsBo.goodsPrice == 0 && goodsBo.productType != 'sample') ? _c('p', {
      staticClass: "price"
    }, [_vm._v(" " + _vm._s(goodsBo.unitPrice == 0 ? '' : '￥' + (goodsBo.unitPrice / 100).toFixed(2)))]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.firstCatCode == 'spike') ? _c('div', {
    staticClass: "bd"
  }, [_c('ul', {
    staticClass: "miaosha-ul"
  }, _vm._l((_vm.goodsList), function(goodsBo) {
    return _c('li', [_c('p', {
      staticClass: "pic tc"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": goodsBo.imgMiddle,
        "width": "265",
        "height": "265"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "title"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.toGoodsDetail(goodsBo.goodsCode, goodsBo.productType)
        }
      }
    }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co3"
    }, [_vm._v("￥" + _vm._s((goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
      staticClass: "old"
    }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "pinpainow_item_time"
    }, [(goodsBo.saleStatus === 'end') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t已结束                       \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距开始 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
      staticClass: "brandsknow_time_txt"
    }, [_vm._v("                         \n                \t\t\t\t距结束 "), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
      staticClass: "brandsknow_time_txt_time"
    }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒                        \n                \t\t\t")]) : _vm._e()])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dp-pages tc"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.prePage()
      }
    }
  }, [_vm._v(" < ")]), _vm._v(" "), _vm._l((_vm.pageList), function(page) {
    return _c('a', {
      class: {
        "current_page": _vm.currentPage === page
      },
      on: {
        "click": function($event) {
          _vm.queryByPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])
  }), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.nextPage()
      }
    }
  }, [_vm._v(" > ")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("首页")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', [_vm._v("精品推荐")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb20 ad-4 mt20"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/footer-ad-1.png"),
      "width": "1200",
      "height": "60"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d79e83aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/goods/goodsList.vue
// module id = P5WD
// module chunks = 1